import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const ChevronLeft: React.FC<IconProps> = ({
  color = '#fff',
  size = 28,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M17.6877 18.8444L12.844 14.0008L17.6877 9.1571C18.2019 8.64291 18.2019 7.80925 17.6877 7.29506C17.1735 6.78087 16.3399 6.78087 15.8257 7.29506L9.93308 13.1876C9.48397 13.6367 9.48398 14.3649 9.93309 14.814L15.8257 20.7065C16.3399 21.2207 17.1735 21.2207 17.6877 20.7065C18.2019 20.1923 18.2019 19.3586 17.6877 18.8444Z"
      fill={color}
      stroke={color}
    />
  </svg>
)
